import { ReactNode } from 'react';

interface NavItemProps {
  title: string;
  icon: ReactNode;
  onClick: () => void;
  active?: boolean;
}

export const NavItem = ({ title, icon, onClick, active = false }: NavItemProps) => {
  return (
    <div
      className={`mx-2 flex items-center gap-2 rounded px-2 py-2 text-xs transition-colors duration-150 hover:cursor-pointer hover:bg-gray-100 ${
        active ? 'border-gray-200 bg-gray-200 font-medium hover:bg-gray-200' : ''
      }`}
      onClick={onClick}
    >
      <span className="flex-shrink-0">{icon}</span>
      <span className="overflow-hidden text-ellipsis whitespace-nowrap">{title}</span>
    </div>
  );
};

interface NavGroupProps {
  title: string;
  children: React.ReactNode;
}

export const NavGroup = ({ title, children }: NavGroupProps) => (
  <div className="mb-3">
    <div className="mb-1 border-b px-2 pt-2 pb-1 text-xs font-semibold text-gray-600">{title}</div>
    <div className="flex flex-col gap-1">{children}</div>
  </div>
);
